import type { DragEvent, ReactNode } from 'react';
import { PanelCard } from '@renderer/shared/components/primitives';
import type { TaskBoardColumnViewModel } from '../tasks-selectors';

export function TaskBoardColumn({
  column,
  children,
  onDropToColumnEnd
}: {
  column: TaskBoardColumnViewModel;
  children: ReactNode;
  onDropToColumnEnd: (event: DragEvent<HTMLDivElement>) => void;
}): JSX.Element {
  return (
    <PanelCard
      className={['av-task-board__column', `av-task-board__column--${column.status}`, column.isArchive ? 'is-archive' : ''].filter(Boolean).join(' ')}
      title={
        <div className="av-task-board__column-header">
          <span>{column.label}</span>
          <span className={`av-task-board__count av-task-board__count--${column.status}`}>{column.count}</span>
        </div>
      }
    >
      <div
        className="av-task-board__column-body"
        onDragOver={(event) => {
          event.preventDefault();
        }}
        onDrop={(event) => {
          event.preventDefault();
          onDropToColumnEnd(event);
        }}
      >
        {children}
      </div>
    </PanelCard>
  );
}
